import { useLanguage } from "../../context/LanguageContext";
import { useEffect, useState } from "react";
/* import { translateContentData } from "../translations/html/en-translateLevelContentData"; */

export const useLevelContentData = (rawData, courseSlug) => {
  const { language } = useLanguage();
  const [translationData, setTranslationData] = useState(null);

  console.log("HOOK courseSlug:", courseSlug);

  useEffect(() => {
    if (!courseSlug) {
      setTranslationData(null);
      return;
    }
    let isMounted = true;

    import(`../translations/${courseSlug}/${language}-translateLevelContentData.js`)  
    .then((module) => {
      if (isMounted) {
        setTranslationData(module.translateLevelContentData?.[language] || []);
      }
    })
    .catch(() => 
      import(`../translations/${courseSlug}/en-translateLevelContentData.js`)
        .then((fallback) => {
          if (isMounted) {
            setTranslationData(fallback.translateLevelContentData?.en || {});
          }
        })
    );
    console.log("Importing from:", `../translations/${courseSlug}/${language}-translateLevelContentData.js`);

    
    return () => {
      isMounted =false;
    };
  }, [language, courseSlug]);

  if (!courseSlug) return rawData ?? [];

  if (!translationData) return rawData ?? [];
 
  return (rawData ?? []).map((level) => {
    const {
      title,
      description = [],
      contentItems = [],
      lectures = [],
      videos = [],
      docs = [],
      utils = [],
    } = level;

  //console.log("RAW TITLE:", title);
  //console.log("TRANSLATION LOOKUP:", translationData.level?.[title]);
  //console.log("AVAILABLE DESCRIPTION KEYS:", Object.keys(translationData.description || {})); 
  
  //console.log("Translated Data:", translationData); //huge data here 

  return {
    ...level,

    title: translationData.level?.[title] || title,

    description: Array.isArray(description)
      ? description.map((desc) => translationData.description?.[desc] || desc)
      : translationData.description?.[description] || description,

    packageDescription:
      translationData.packageDescription?.[level.packageDescription] ||
      level.packageDescription,

    contentItems: contentItems.map((key) => translationData.contentItems?.[key] || key),

    packageFeatures: (level.packageFeatures || []).map(
      key => translationData.packageFeatures?.[key] || key
    ),

    lectures: lectures.map((group) => ({
      ...group,
      list: group.list.map((key) => ({
        stableKey: key,
        title: translationData.lectures?.[key] || key,
      })),
    })),
    videos: videos.map((group) => ({
      ...group,
      list: (group?.list ?? []).map((key) => translationData.videos?.[key] || key),
    })),
    docs: docs.map((group) => ({
      ...group,
      list: (group?.list ?? []).map((key) => translationData.docs?.[key] || key),
    })),
    utils: utils.map((key) => translationData.utils?.[key] || key),
  };
  });
}
